// extracted by mini-css-extract-plugin
module.exports = {"containerTab":"ProductTabCategory_containerTab__EQMO_","rowProduct":"ProductTabCategory_rowProduct__2p2df"};